"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TradeInRepairSpotlight() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: listRef,
    isVisible: listVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const services = [{
    number: "01",
    name: "Device Trade-In",
    description: "Upgrade your mobile experience by trading in your current flagship device for instant credit toward the latest models.",
    price: "UP TO $800"
  }, {
    number: "02",
    name: "Screen Repair",
    description: "Professional-grade display replacement using original manufacturer components to restore your device's visual clarity.",
    price: "FROM $120"
  }, {
    number: "03",
    name: "Battery Diagnostics",
    description: "Comprehensive power cycle analysis and battery replacement to ensure your device maintains peak performance all day.",
    price: "FROM $75"
  }];
  return <section data-section-id="5115" id="trade-in-repair-spotlight" className="dark relative bg-background text-foreground overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-y-0 right-0 w-full md:w-3/5 opacity-20 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701038/img/tech_repair_bench.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701038/img/tech_repair_bench.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701038/img/tech_repair_bench.png-wvc-sizes" alt="Precision mobile device repair workbench" loading="lazy" decoding="async" className="w-full h-full object-cover object-right" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/70 to-transparent" />
      </div>

      {}
      <div className="absolute right-4 md:right-12 top-1/2 -translate-y-1/2 font-default text-foreground pointer-events-none select-none hidden md:block" style={{
      fontSize: "clamp(12rem, 28vw, 28rem)",
      opacity: 0.05,
      lineHeight: 1
    }} aria-hidden="true">
        TW
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8">
          {}
          <div ref={headerRef} className={`col-span-12 lg:col-span-7 mb-16 md:mb-24 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="font-mono text-xs tracking-widest mb-12 text-primary">
              N°.04 — TECHWIRE SERVICES
            </p>
            <h2 className="font-default font-bold text-5xl md:text-7xl lg:text-8xl leading-[1.05] text-foreground">
              We optimize
              <br />
              your mobile
              <br />
              ecosystem.
            </h2>
          </div>
        </div>

        {}
        <div ref={listRef} className={`transition-all duration-1000 ease-out ${listVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="border-t border-border">
            {services.map((service, i) => <div key={i} data-index={i} className="group border-b border-border transition-colors duration-500 hover:bg-card cursor-pointer">
                <div className="grid grid-cols-12 gap-4 md:gap-8 items-center py-10 md:py-12 px-2 md:px-4">
                  {}
                  <div className="col-span-2 md:col-span-1">
                    <span className="font-mono text-sm md:text-base transition-colors duration-500 text-primary">
                      <span className="group-hover:hidden">{service.number}</span>
                      <span className="hidden group-hover:inline text-primary">
                        {service.number}
                      </span>
                    </span>
                  </div>

                  {}
                  <div className="col-span-10 md:col-span-4">
                    <h3 className="font-default font-semibold text-2xl md:text-3xl text-foreground leading-tight">
                      {service.name}
                    </h3>
                  </div>

                  {}
                  <div className="col-span-12 md:col-span-4 md:pl-4">
                    <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed">
                      {service.description}
                    </p>
                  </div>

                  {}
                  <div className="col-span-8 md:col-span-2">
                    <span className="font-mono text-xs md:text-sm tracking-widest text-foreground">
                      {service.price}
                    </span>
                  </div>

                  {}
                  <div className="col-span-4 md:col-span-1 flex justify-end">
                    <ArrowRight className="w-5 h-5 md:w-6 md:h-6 text-primary transition-transform duration-500 group-hover:translate-x-3" strokeWidth={1.5} />
                  </div>
                </div>
              </div>)}
          </div>

          {}
          <div className="mt-16 md:mt-20">
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-xs tracking-widest h-14 px-8 shadow-md">
              <Link to="/TradeInRepairsPage">
                BOOK A SERVICE APPOINTMENT
                <ArrowRight className="w-4 h-4 ml-2" strokeWidth={1.5} />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}